module.exports = __webpack_public_path__ + "static/media/perimeter.e44bd40d.png";